import React from 'react';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import { formatRange } from '../../utils';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import DateRangeCustom from '../../Dashboard/Elevation/Components/DateRange';

const useStyles = makeStyles(theme => ({
    button: {
        padding: "9px 18.5px",
        width: "100%",
        fontWeight: 400,
        maxWidth: "360px",
        marginRight: theme.spacing(2),
        '& .MuiButton-label': {
            justifyContent: "flex-start",
            textTransform: "none",
            fontSize: "1rem",
            color: theme.palette.primary.main
        },
        [theme.breakpoints.down('sm')]: {
            marginRight: 0,
            marginBottom: theme.spacing(2),
        },
    },
    dialog: {
        '& .MuiDialog-paperWidthSm': {
            width: "auto"
        }
    },
    actions: {
        display: "flex",
        justifyContent: "space-between"
    },
}));


const DateRangeSelector = ({ handleClearClick, range, handleCloseClick, showDialog, setRange, setShowDialog, shouldSetQueryStringRange }) => {
    const classes = useStyles()

    return (
        <Box>
            <Button
                className={classes.button}
                variant="outlined"
                onClick={() => setShowDialog(true)}
            >
                {range.to && range.from ?
                    formatRange(range).from + " - " + formatRange(range).to
                    :
                    "Filter dashboard by date"
                }
            </Button>
            <Dialog
                className={classes.dialog}
                open={showDialog}
                onBackdropClick={handleCloseClick}
            >
                <DialogContent>
                    <DateRangeCustom range={range} setRange={setRange} shouldSetQueryStringRange={shouldSetQueryStringRange}/>
                </DialogContent>
                <DialogActions className={classes.actions}>
                    <Button
                        label="ra.action.cancel"
                        onClick={handleClearClick}
                    >
                        Clear interval
                    </Button>
                    <Button
                        color="secondary"
                        label="ra.action.cancel"
                        onClick={handleCloseClick}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default DateRangeSelector
